import React, { useEffect, useState } from "react";
import Body from "src/components/common/Body";
import Box from "src/components/common/Box";
import Select from "src/components/common/Select";
import InputFile from "src/components/common/InputFile";
import Textarea from "src/components/common/Textarea";
import Button from "src/components/common/Button";
import styled from "styled-components";
import { useAppSelector } from "src/store/actions/action";
import { useAddAsMutation, useAsDetailQuery, useUpdateAsMutation } from "src/api/asAPI";
import { is } from "immer/dist/internal";
import { useNavigate } from "react-router-dom";
import { getPathValue } from "src/utils/queryStringUtil";
import asDetail from "./asDetail";
import { RotatingLines } from "react-loader-spinner";
import ErrorParser from "src/utils/jsonParser";
import { useDispatch } from "react-redux";
import { addRegisterIng } from "src/store/reducers/asReduce";
import { createBrowserHistory } from "history";

const asRegister = () => {
  const example = [
    {
      value: "1201000",
      name: "마감재(벽,바닥,천장)",
    },
    {
      value: "1202000",
      name: "집기",
    },
    {
      value: "1203000",
      name: "마네킨",
    },
    {
      value: "1204000",
      name: "전기/조명",
    },
    {
      value: "1205000",
      name: "음향",
    },
    {
      value: "1206000",
      name: "영상",
    },
    {
      value: "1207000",
      name: "간판/로고",
    },
    {
      value: "1208000",
      name: "설비/누수/소방",
    },
    {
      value: "1209000",
      name: "기타",
    },
  ];

  // +++++++++++++++++++++++++++++++++++++ 퍼블 영역 끝 +++++++++++++++++++++++++++++++++++++

  // 라이브러리 세팅
  const asIndex = getPathValue();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const cHisotry = createBrowserHistory();

  // 초기 값 세팅
  const [inputs, setInputs] = useState({
    cate_idx: "1201000",
    contents: "",
    images: [],
  });

  const [propsData, setPropsData] = useState<any>([]);
  const [imageIndexData, setImageIndexData] = useState<any>([]);

  const { cate_idx, contents, images } = inputs;

  const [apiSkip, setApiSkip] = useState(true);
  const [clickRegisterBtn, setClickRegisterBtn] = useState<boolean>(false);

  // API 영역
  const asDetailAPI = useAsDetailQuery(asIndex, { skip: apiSkip });

  const [insertStart, { isError, isSuccess, isLoading, error }] = useAddAsMutation();

  const [updateAs, { isLoading: updateLoading, isSuccess: updateSuccess, isError: updateIsError, error: updateError }] = useUpdateAsMutation();

  // 생명주기 영역

  useEffect(() => {
    const backEvent = () => {
      if (clickRegisterBtn) {
        dispatch(addRegisterIng(true));
      }
    };
    const unlistenHistoryEvent = cHisotry.listen(({ action }) => {
      if (action === "POP") {
        backEvent();
      }
    });
    return unlistenHistoryEvent;
  }, [clickRegisterBtn]);

  useEffect(() => {
    if (asIndex) {
      setApiSkip(false);
    }
  }, [asIndex]);

  useEffect(() => {
    if (isLoading) {
    }
  }, [isLoading]);

  useEffect(() => {
    if (isSuccess) {
      // 화면 전환
      setClickRegisterBtn(false);
      navigate("/home", { replace: true });
    }
  }, [isSuccess]);

  useEffect(() => {
    if (updateSuccess) {
      navigate("/as-detail/" + asIndex, { replace: true });
    }
  }, [updateSuccess]);

  useEffect(() => {
    if (asDetailAPI.isSuccess) {
      setInputs({
        ...inputs,
        cate_idx: asDetailAPI.data.cate_idx,
        contents: asDetailAPI.data.contents,
        images: asDetailAPI.data.images,
      });
    }
  }, [asDetailAPI]);

  useEffect(() => {
    if (isError) {
      const message = ErrorParser(error);
      alert(message);
    }
    if (updateIsError) {
      const message = ErrorParser(updateError);
      alert(message);
    }
  }, [isError, updateIsError]);

  // 이벤트 함수 영역
  const asRegiste = async () => {
    if (asIndex) {
      // 수정
      if (cate_idx === "") {
        alert("카테고리를 선택해 주세요");
        return;
      }
      if (contents === "") {
        alert("A/S가 필요한 내용을 작성해 주세요");
        return;
      }
      const form = new FormData();
      form.append("cate_idx", cate_idx);
      form.append("contents", contents);

      if (imageIndexData.length >= images.length && propsData.length <= 0) {
        alert("A/S가 필요한 곳의 사진을 첨부해주세요");
        return;
      }

      for (let i = 0; i < imageIndexData.length; i++) {
        form.append("delete_imgs", imageIndexData[i].img_idx);
      }

      for (let i = 0; i < propsData.length; i++) {
        form.append("images", propsData[i]);
      }
      const data = {
        as_idx: asIndex,
        data: form,
      };
      updateAs(data);
    } else {
      // 등록
      if (cate_idx === "") {
        alert("카테고리를 선택해 주세요");
        return;
      }
      if (contents === "") {
        alert("내용을 입력해 주세요");
        return;
      }
      const form = new FormData();
      form.append("cate_idx", cate_idx);
      form.append("contents", contents);
      if (propsData.length <= 0) {
        alert("이미지를 등록해 주세요");
        return;
      }
      for (let i = 0; i < propsData.length; i++) {
        form.append("images", propsData[i]);
      }
      insertStart(form);
    }
    setClickRegisterBtn(true);
  };

  const onChange = (e: any) => {
    const { value, id } = e.target;
    setInputs({
      ...inputs,
      [id]: value,
    });
  };

  const historyBackBtn = (history: number) => {
    //
    if (clickRegisterBtn) {
      dispatch(addRegisterIng(true));
    }
    navigate(history);
  };

  return (
    <>
      <header>
        <div>
          <Button variant="text" className="btn-back" onClick={() => historyBackBtn(-1)}>
            A/S
          </Button>
        </div>
        <div className="btn-box">
          {isLoading ? (
            <p style={{ textAlign: "center" }}>
              <RotatingLines width="20" strokeColor="#00263e" strokeWidth="1" />
            </p>
          ) : updateLoading ? (
            "수정 중 ..."
          ) : (
            <Button variant="text" onClick={() => asRegiste()}>
              {asIndex ? "수정" : "등록"}
            </Button>
          )}
        </div>
      </header>

      <Body type="detail">
        <Box pd="5px 15px 15px">
          <Select options={example} id="cate_idx" defaultValue={cate_idx} onChange={(e) => onChange(e)}></Select>
        </Box>

        <WriteWrap>
          <InputFile className="input-file" setPropsData={setPropsData} registeredImage={images} setImageIndexData={imageIndexData} />
          <Textarea className="textarea-wrap" value={contents} id="contents" placeholder="A/S 건에 대해 자세히 설명해주세요!" onChange={(e) => onChange(e)} />
        </WriteWrap>
      </Body>
    </>
  );
};

const WriteWrap = styled.div`
  ${({ theme }) => theme.flexBox.flexMixin("column", "space-between", "stretch")}
  height: calc(100% - 60px);
  padding: 0 15px;
  .input-file {
    flex-basis: 75px;
  }
  .textarea-wrap {
    flex: 1;
  }
`;

export default asRegister;
